import { dlCustomGA4Event } from './custom/dl.custom.GA4.event';
export const dispatchGAEvent = (category, action, label) => {
    const actionLower = String(action).toLowerCase();
    window.ga('send', 'event', category, actionLower, label);
    dlCustomGA4Event(category, actionLower, label);
};
